<template>
  <!-- 对话框 -->
  <el-drawer title="添加司机信息" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">

    <!-- 基本信息表单 -->
    <div class="form-box">

      <template>

        <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto;">

          <el-form-item label="持卡人:" label-width='120px'>
            <el-input v-model="submit_data.bank_card_name" :placeholder="submit_rules.bank_card_name.placeholder" style="width: 80%;">
            </el-input>
          </el-form-item>

          <el-form-item label="卡号:" label-width='120px'>
            <el-input v-model="submit_data.bank_card_no" :placeholder="submit_rules.bank_card_no.placeholder" maxlength='19'
              style="width: 80%;">
            </el-input>
          </el-form-item>


          <el-form-item label="开户行:" label-width='120px'>
            <el-input v-model="submit_data.address" :placeholder="submit_rules.address.placeholder" style="width: 80%;">
            </el-input>
          </el-form-item>


        </el-form>



        <!-- 对话框底部按钮 -->
        <div style="display: flex;justify-content: center">
          <el-button type="primary" @click="onSubmit">保存</el-button>
          <el-button @click="closeDialog">关闭</el-button>
        </div>

      </template>



    </div>




  </el-drawer>
</template>

<script>
  var _this;
  export default {
    props: {
      'isShow': Boolean,
      'data':''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        _this.submit_data.driver_bank_card_code = _this.data;
        _this.$post(
            "/driver/getDriverBankCardDetails",{
              driver_bank_card_code:_this.data
            }
          )
          .then(res => {

            _this.submit_data.bank_card_name = res.data.bank_card_name;
            _this.submit_data.bank_card_no = res.data.bank_card_no;
            _this.submit_data.address = res.data.address;


          }).catch(res => {

          })

      },
    },
    data() {
      return {

        show: false,

        // 表单数据
        submit_data: {
          driver_bank_card_code: '',
          bank_card_name: '',
          bank_card_no: '',
          address: ''
        },

        submit_rules: {
          driver_bank_card_code: {
            placeholder: '唯一编码',
            rules: {
              required: true,
              message: '唯一编码错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          bank_card_name: {
            placeholder: '请输入持卡人',
            rules: {
              required: false,
              message: '持卡人错误',
              regulation: 'egt_str',
              rulesData: 2
            }
          },
          bank_card_no: {
            placeholder: '请输入银行卡卡号',
            rules: {
              required: false,
              message: '银行卡卡号错误',
              regulation: 'eq_str',
              rulesData: 19
            }
          },
          address: {
            placeholder: '请输入开户行',
            rules: {
              required: false,
              message: '开户行错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
        },

      };
    },
    created() {

      _this = this;

    },
    methods: {


      // 关闭方法
      closeDialog() {
        _this.show = false;
        for (const key in _this.submit_data) {
          _this.submit_data[key] = '';
        }
      },

      // 提交
      onSubmit() {
        _this.$post(
            "/driver/editDriverBankCardSubmit",
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {

            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();
            this.$message.success(res.msg);

          }).catch(res => {

          })
      },





    }
  };
</script>

<style scoped>
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }
</style>